var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2614_9932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25.5C13.3288 25.5 14.1237 25.1708 14.7097 24.5847C15.2958 23.9987 15.625 23.2038 15.625 22.375H9.375C9.375 23.2038 9.70424 23.9987 10.2903 24.5847C10.8763 25.1708 11.6712 25.5 12.5 25.5ZM12.5 3.4969L11.2547 3.74846C9.84212 4.03627 8.57239 4.80331 7.66039 5.91975C6.7484 7.03618 6.25015 8.43344 6.25 9.87502C6.25 10.8563 6.04062 13.3078 5.53281 15.7219C5.28281 16.9203 4.94531 18.1688 4.49688 19.25H20.5031C20.0547 18.1688 19.7188 16.9219 19.4672 15.7219C18.9594 13.3078 18.75 10.8563 18.75 9.87502C18.7495 8.43371 18.2511 7.03682 17.3391 5.9207C16.4271 4.80459 15.1576 4.03778 13.7453 3.75002L12.5 3.49534V3.4969ZM22.2188 19.25C22.5672 19.9485 22.9703 20.5016 23.4375 20.8125H1.5625C2.02969 20.5016 2.43281 19.9485 2.78125 19.25C4.1875 16.4375 4.6875 11.25 4.6875 9.87502C4.6875 6.09377 7.375 2.93752 10.9453 2.21721C10.9235 1.99995 10.9475 1.78053 11.0157 1.57311C11.0839 1.36568 11.1948 1.17485 11.3413 1.01293C11.4878 0.851003 11.6666 0.721578 11.8661 0.633C12.0657 0.544422 12.2816 0.498657 12.5 0.498657C12.7184 0.498657 12.9343 0.544422 13.1339 0.633C13.3334 0.721578 13.5122 0.851003 13.6587 1.01293C13.8052 1.17485 13.9161 1.36568 13.9843 1.57311C14.0525 1.78053 14.0765 1.99995 14.0547 2.21721C15.8208 2.57643 17.4084 3.53496 18.5488 4.93049C19.6892 6.32603 20.3123 8.0728 20.3125 9.87502C20.3125 11.25 20.8125 16.4375 22.2188 19.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2614_9932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell_icon.30787bc4c23029627e923e3ee2dc216a.svg";
export { ForwardRef as ReactComponent };